import { PERIOD_PRESET_OPTIONS } from './period.constant';

/** Serialization format of a period bound, as stored in the filter value. */
export const PERIOD_DATE_FORMAT = 'YYYY/MM/DD';

/** Separator between the two bounds of a serialized explicit range. */
export const PERIOD_RANGE_SEPARATOR = ' to ';

const DATE_PATTERN = String.raw`\d{4}/\d{2}/\d{2}`;
const RANGE_PATTERN = `${DATE_PATTERN}${PERIOD_RANGE_SEPARATOR}${DATE_PATTERN}`;

/** Explicit range only: `YYYY/MM/DD to YYYY/MM/DD`. */
export const DATE_RANGE_VALUE_REGEX = new RegExp(`^${RANGE_PATTERN}$`);

/** Explicit range or one of the preset keys. */
export const PERIOD_VALUE_REGEX = new RegExp(`^(?:${PERIOD_PRESET_OPTIONS.join('|')}|${RANGE_PATTERN})$`);
